// Der Produkt-Host zeigt die Marketing-Seite direkt im Frontend,
// unabhängig von Tenant-Auflösung über die API. Damit bleibt
// live.von2.media auch dann die Marketing-Seite, wenn API, Proxy
// oder DB-Daten einmal nicht wie erwartet antworten.
// `||` statt `??:` ein leerer String aus Dockerfile.web (ungesetzter ARG)
// würde sonst die Fallback-Liste killen und die Marketing-Seite abschalten.
const PRODUCT_HOSTS = (import.meta.env.VITE_PRODUCT_HOSTS || "live.von2.media")
  .split(",")
  .map((host) => host.trim().toLowerCase())
  .filter(Boolean);

export function isProductHost(
  hostname: string = window.location.hostname,
): boolean {
  const normalized = hostname.toLowerCase().replace(/^www\./, "");
  return PRODUCT_HOSTS.includes(normalized);
}
